export const reduxKey = '@@ArtBrandedPopup';
